import { render, staticRenderFns } from "./QLClassiPericolosita.vue?vue&type=template&id=338c0186&scoped=true&"
import script from "./QLClassiPericolosita.vue?vue&type=script&lang=js&"
export * from "./QLClassiPericolosita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338c0186",
  null
  
)

export default component.exports